<template>
  <div class="fixed z-40">
    <div class="inset-0 fixed w-full h-full bg-black opacity-20">
    </div>
    <div class="inset-4 fixed">
      <div class="w-fit max-w-full mx-auto mt-16 bg-white rounded-xl border-4 text-center py-5 drop-shadow-lg">
        <div v-html="contents" class="px-2 break-words"></div>
        <div class="text-center pt-2 flex justify-center mx-auto w-80">
          <button class="mx-auto mt-2 mx-4 font-bold text-xl w-32 rounded-md py-1 text-white bg-blue-600" @click="close()">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contents: {
      type: String,
    },
  },
  methods: {
    close: function () {
      this.$store.commit('setAlertModal');
    }
  }
}
</script>
